import { isEmpty } from 'lodash';

/**
 * Filter users based on selected alumni programs
 * @param {Array} selectedPrograms - Array of selected program names or objects
 * @returns {Function} A filter function that returns true for users with matching programs
 */
export const filterUserWithAlumni = (selectedPrograms) => {
  // If no programs are selected, return all users
  if (!selectedPrograms || !Array.isArray(selectedPrograms) || selectedPrograms.length === 0) {
    return () => true;
  }

  return (user) => {
    // If user doesn't have programs data, skip them
    if (!user || !user.programs || !Array.isArray(user.programs) || user.programs.length === 0) {
      return false;
    }

    // Extract program names from the filter for easier matching
    const selectedProgramNames = selectedPrograms.map(program => 
      typeof program === 'string' ? program : program.name
    );

    // Check if any of the user's programs match the selected programs
    return user.programs.some(userProgram => {
      // Handle both string values and object values
      const programName = typeof userProgram === 'string' ? userProgram : userProgram.name;
      return selectedProgramNames.includes(programName);
    });
  };
};

export default filterUserWithAlumni;
